var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnvillogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 125.36 168.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 64.33,
    y1: 173.41,
    x2: 107.1,
    y2: 13.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c61682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e50051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7800"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M46.25,114.52c-13.61-6.4-17.26-21-16.66-31.63A62.83,62.83,0,0,0,50.1,179.58c9.27,3.66,19.89.17,19.95-8.54V166c0-2.47-1.79-4.11-4.29-4.36C53,160.3,40.12,154.87,32.7,142.92h85.77v6.55c0,3.84-1.63,6.08-5,6.8-7.32,1.57-15.81,3.55-23.14,5.12-2.78.63-4.81,2-4.82,4.56V171c.06,8.71,10.69,12.21,20,8.54a63,63,0,0,0,31.24-34.64c4-10.73,4.93-21.91,1.44-32.94-2.32-7.35-3.9-14.09,1.68-18-5.78-4.72-20.48-5.18-33.25,4L82.75,115.09l8.77,12.22L75.35,138.9,56.2,112.19A21.61,21.61,0,0,0,57.36,94l6.77-4.86,12.65,17.64,29.73-21.31c29.5-21.92,8.11-68-28.72-73.07C88.2,32.07,85.22,47,67.43,57.67a80.91,80.91,0,0,0-11.91,8.46,42.83,42.83,0,0,0-12.85,18.6c-3,9.17-2.26,19.42,3.58,29.79Zm-3-44.72c.9-8.07,4.75-15.91,9.27-21.82,4-5.2,5.69-8.93,5.19-14.65,10.12,3.32,9.9,13.74,2.42,19.6C55,57,48.28,62.33,43.3,69.8Zm20.19,69.1a33.22,33.22,0,0,1-31.43-21.41C42.56,130.83,57.88,127.17,63.49,138.9Z",
    transform: "translate(-14.97 -12.38)",
    style: {
      fillRule: "evenodd",
      fill: "url(#a)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnvillogo);
export default __webpack_public_path__ + "static/media/anvillogo.fe03322925f57070bbcdd282ef4ebc32.svg";
export { ForwardRef as ReactComponent };